
riot.tag2('currency-new-modal', '  <bs-modal>\n    <yield to="title">\n      <div class="h4 modal-title">{parent.opts.title || \'Добавить новую валюту\'}</div>\n    </yield>\n    <yield to="body">\n      <form name="form" onchange="{change}" onkeyup="{change}">\n        <div class="row">\n          <div class="col-md-6">\n            <div class="form-group {has-error: error.name}">\n              <label class="control-label">Обозначение*</label>\n              <input class="form-control" name="name" value="{item.name}">\n              <div class="help-block">{error.name}</div>\n            </div>\n          </div>\n          <div class="col-md-6">\n            <div class="form-group">\n              <label class="control-label">Предустановки</label>\n              <select class="form-control" value="{item.name}" onchange="{currencyChange}">\n                <option value=""></option>\n                <option each="{currencies}" value="{charCode}">{name}</option>\n              </select>\n            </div>\n          </div>\n        </div>\n        <div class="row">\n          <div class="col-md-6">\n            <div class="form-group {has-error: error.title}">\n              <label class="control-label">Название*</label>\n              <input class="form-control" name="title" value="{item.title}">\n              <div class="help-block">{error.title}</div>\n            </div>\n          </div>\n          <div class="col-md-6">\n            <div class="form-group">\n              <label class="control-label">Пред. текст</label>\n              <input class="form-control" name="nameFront" value="{item.nameFront}">\n            </div>\n          </div>\n        </div>\n        <div class="row">\n          <div class="col-md-6">\n            <div class="form-group">\n              <label class="control-label">Заверш. текст</label>\n              <input class="form-control" name="nameFlang" value="{item.nameFlang}">\n            </div>\n          </div>\n          <div class="col-md-6">\n            <div class="form-group">\n              <label class="control-label">Код по ЦБРФ</label>\n              <input class="form-control" name="cbrKod" value="{item.cbrKod}">\n            </div>\n          </div>\n        </div>\n        <div class="row">\n          <div class="col-md-6">\n            <div class="form-group">\n              <label class="control-label">Мин. сумма</label>\n              <input class="form-control" name="minSum" min="0.01" step="0.01" value="{item.minSum}" type="{\'number\'}">\n            </div>\n          </div>\n        </div>\n      </form>\n    </yield>\n    <yield to="footer">\n      <button class="btn btn-default btn-embossed" onclick="{modalHide}" type="button">Закрыть</button>\n      <button class="btn btn-primary btn-embossed" onclick="{parent.opts.submit.bind(this)}" type="button">Сохранить</button>\n    </yield>\n\n  </bs-modal>\n', '', '', function(opts) {
'use strict';

var _extends2 = require('babel-runtime/helpers/extends');

var _extends3 = _interopRequireDefault(_extends2);

function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { 'default': obj }; }

var self = this;

self.on('mount', function () {
    var modal = self.tags['bs-modal'];

    modal.mixin('validation');
    modal.mixin('change');
    modal.item = opts.item || { minSum: 0.01 };
    modal.error = false;

    modal.rules = {
        name: 'empty',
        title: 'empty'
    };

    modal.afterChange = function (e) {
        var name = e.target.name;
        delete modal.error[name];
        modal.error = (0, _extends3.default)({}, modal.error, modal.validation.validate(modal.item, modal.rules, name));
    };

    modal.currencyChange = function (e) {
        var value = e.target.value;
        var item = modal.currencies.filter(function (item) {
            return item.charCode == value;
        });

        if (item.length) {
            modal.item.cbrKod = item[0].id;
            modal.item.name = item[0].charCode;
            modal.item.title = item[0].name;
        }

        modal.error = modal.validation.validate(modal.item, modal.rules);
    };

    API.request({
        object: 'EnumValutes',
        method: 'Fetch',
        success: function success(response) {
            modal.currencies = response.items;
            self.update();
        }
    });
});
});


// WEBPACK FOOTER //
// ./pages/settings/currencies/currency-new-modal.tag